<template>
  <div id="manage">
    <div class="content">
        <div class="title">退班管理</div>
        <div class="botBox">
            <div class="bottomBox">
                <div class="selVox">
                    <div class="fl_left">
                        <input type="password"  autocomplete="new-password" style="display: none;">
                        <Input
                        id="demo"
                        v-model="keyword"
                        icon="ios-search"
                        placeholder="学员姓名/联系电话/证件号"
                        style="width: 330px;height:34px;border:1px solid #e7e7eb;margin:20px 0;"
                        class="bradius"
                        @on-click="search(1)"
                        @keyup.enter.native="search(1)"
                        autocomplete="off"></Input>
                    </div>
                    <!-- <div class="fl_right addClass" @click="addRecruit">新增学员</div> -->
                </div>
                <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">
                    <Table :columns="columns7" :data="data6" :loading="loading"></Table>
                </div>
                <Page :page-size="pageSize" :total="total" show-total :current="pageNum" @on-change="updatePage" style="position:absolute;bottom:20px;left:38%;"></Page>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'manage',
        data () {
            return {
                name:'',
                keyword:'',
                level_id:'',
                levelArr:[],
                levalId:'',
                levelList:[],
                dance:'',
                danceList:[],
                dance_id:'',
                phone:'',
                teatsex:'0',
                teacher_id:'',
                total:null,
                pageNum:1,
                pageSize:10,
                loading:false,
                stop_reason:'',
                columns7: [
                    {
                        title: '序号',
                        type: 'index',
                        align: 'center',
                        width:80
                    },
                    {
                        title: '学员',
                        align: 'center',
                        key: 'name',
                        width:230,
                        render: (h, params) => {
                            if(params.row.sex==1){
                                return h('div',{
                                    style:{
                                        overflow:'hidden',
                                        padding:'10px 0'
                                    }
                                },[
                                    h('img',{
                                        style:{
                                            width:'47px',
                                            height:'60px',
                                            display:'block',
                                            float:'left'
                                        },
                                        domProps: {
                                            src:params.row.avater
                                        }
                                    }),
                                    h('div',{
                                        style:{
                                            width:'150px',
                                            float:'left',
                                            margin:'0px 0 0 11px'
                                        },
                                    },[
                                        h('div',{
                                            style:{
                                                width:'150px',
                                                overflow:'hidden'
                                            },
                                        },[
                                            h('div',{
                                                style:{
                                                    float:'left'
                                                }
                                            },params.row.name),
                                            h('div',{
                                                style:{
                                                    background:'url(static/imgs/man.png) left center / 12px no-repeat',
                                                    margin:'0 0 0 5px',
                                                    width:'12px',
                                                    height:'21px',
                                                    float:'left'
                                                }
                                            })
                                        ]),
                                        h('div',{
                                            style:{
                                                textAlign:'left'
                                            }
                                        },params.row.card_code),
                                        h('div',{
                                            style:{
                                                textAlign:'left'
                                            }
                                        },params.row.code_type==0?'【护照】':params.row.code_type==1?'【大陆身份证】':params.row.code_type==2?'【港澳身份证】':params.row.code_type==3?'【台湾居民来往通行证】':'')
                                    ])
                                ]);
                            }
                            else if(params.row.sex==0){
                                return h('div',{
                                    style:{
                                        overflow:'hidden',
                                        padding:'10px 0'
                                    }
                                },[
                                    h('img',{
                                        style:{
                                            width:'47px',
                                            height:'60px',
                                            display:'block',
                                            float:'left'
                                        },
                                        domProps: {
                                            src:params.row.avater
                                        }
                                    }),
                                    h('div',{
                                        style:{
                                            width:'150px',
                                            float:'left',
                                            margin:'0px 0 0 11px'
                                        },
                                    },[
                                        h('div',{
                                            style:{
                                                width:'150px',
                                                overflow:'hidden'
                                            },
                                        },[
                                            h('div',{
                                                style:{
                                                    float:'left'
                                                }
                                            },params.row.name),
                                            h('div',{
                                                style:{
                                                    background:'url(static/imgs/girl.png) left center / 10px no-repeat',
                                                    margin:'0 0 0 5px',
                                                    width:'12px',
                                                    height:'21px',
                                                    float:'left'
                                                }
                                            })
                                        ]),
                                        h('div',{
                                            style:{
                                                textAlign:'left'
                                            }
                                        },params.row.card_code),
                                        h('div',{
                                            style:{
                                                textAlign:'left'
                                            }
                                        },params.row.code_type==0?'【护照】':params.row.code_type==1?'【大陆身份证】':params.row.code_type==2?'【港澳身份证】':params.row.code_type==3?'【台湾居民来往通行证】':'')
                                    ])
                                ]);
                            }
                        }
                    },
                    {
                        title: '承办单位',
                        align: 'center',
                        key: 'company_name',
                    },
                    {
                        title: '培训期次',
                        align: 'center',
                        key: 'term_name',
                    },
                    {
                        title: '班级名称',
                        align: 'center',
                        key: 'class_name',
                    },
                    {
                        title: '上课时间',
                        align: 'center',
                        key: 'date_show',
                    },
                    {
                        title: '退班原因',
                        align: 'center',
                        key: 'del_reason',
                    },
                    {
                        title: '联系电话',
                        align: 'center',
                        key: 'phone',
                    },
                ],
                data6: [],
                alertShow:false,
                valm:0,
            }
        },
        methods:{
            search(index){
                let _this=this;
                if(index==1){
                    _this.pageNum=1;
                }
                _this.$axios.post('getremovestudentlist',{
                    keyword:_this.keyword,
                    page:_this.pageNum,
                }).then(res=>{
                    if(res.data.code==200){
                        _this.total=res.data.data.total;
                        _this.data6=res.data.data.list;
                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            updatePage(num) {
                this.pageNum = num;
                this.search(0);
            },
            addRecruit(){
                let _this=this;
                _this.valm=0;
                _this.name='';
                _this.dance='';
                _this.level_id='';
                _this.teatsex='0';
                _this.getprovince();
                _this.phone='';
                _this.alertShow=true;
            },
            getprovince(){
                let _this=this;
                _this.$axios.post('getdancelist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.danceList=res.data.data;
                        _this.dance=res.data.data[0].id;
                        _this.getLvel(1);
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getLvel(index){
                let _this=this;
                _this.$axios.post('getlevellist',{dance_id:index===0?_this.dance_id:_this.dance}).then(res=>{
                    if(res.data.code==200){
                        _this.levelArr=res.data.data;
                        _this.levelList=res.data.data;
                        if(index===0){
                            _this.levalId=res.data.data[0].id
                        }
                        else{
                            _this.level_id=res.data.data[0].id;
                        }
                        index===0?_this.search(1):'';
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getscity(){
                let _this=this;
                _this.$axios.post('getdancelist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.danceList=res.data.data;
                        if(res.data.data.length!=0){
                            _this.dance_id=res.data.data[0].id;
                            _this.getLvel(0);
                        }
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
        },
        created(){
            let _this=this;
            _this.search();
        }
    }
</script>

<style scoped>
/**/
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
/**/
    .urlLogo{
        width: 150px;
        height: 210px;
        /*background: #f5f5fa url('../../../static/imgs/baadd.png') center center/30px no-repeat;*/
        border: solid 1px #e5e5e5;
        position: relative;
        overflow: hidden;
    }
    .urlLogo input{
        position: absolute;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
    }
    .urlLogo img{
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        /*z-index: 999;*/
    }
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 116px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 58px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e6e6e6;
        padding: 0 20px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }
    .showBox{
        position: absolute;
        right: 20px;
        top:65px;
        z-index: 99;
    }
    .shdawBot{
        padding: 0 30px 15px;
        box-sizing: border-box;
    }
    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/teacher/tui.vue